<template>
  <div :id="id" class="v-anchor"></div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: null
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

$mobile-offset: $nav-height-mobile + 16;
$desktop-offset: $nav-height-desktop + 24;

.v-anchor {
  scroll-margin-block-start: $mobile-offset;

  @include media-breakpoint-up(md) {
    scroll-margin-block-start: $desktop-offset;
  }
}
</style>
